import { SeoSearch } from '@travelata-libs/travelata-frontend';
import Vue from 'vue';
import { getSsrMountTarget } from '@shared/lib';
import { createHeaderBindings } from './headerBindings';
import { readSeoAnchorProps } from './readSeoAnchorProps';

const HOST_ANCHOR_SELECTOR = '#js-lib-search-form-host';

interface SeoTitleExtension {
    props?: Record<string, unknown>;
    listeners?: Record<string, (...args: never[]) => void>;
}

export function mountLibSeoTitle(extend?: (seoProps: Record<string, unknown>) => SeoTitleExtension): void {
    if (typeof document === 'undefined') {
        return;
    }

    const anchor = document.querySelector(HOST_ANCHOR_SELECTOR);
    if (!anchor) {
        return;
    }

    const seoProps = readSeoAnchorProps(anchor);
    const header = createHeaderBindings();
    const extension = extend?.(seoProps) ?? {};

    new Vue({
        name: 'LibSeoTitleRoot',
        render: (createElement) => createElement(SeoSearch, {
            props: { ...seoProps, ...header.props, user: header.auth.user, ...extension.props },
            on: { ...header.listeners, ...extension.listeners },
        }),
    }).$mount(getSsrMountTarget(anchor));
}
